<script setup>
import { onMounted, computed, ref } from 'vue';
import { useBannersStore } from '@/stores/banners';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { useRouter } from 'vue-router';

const bannersStore = useBannersStore();
const router = useRouter();

const is_rtl = ref(false);

const hasBanners = computed(() => bannersStore.getRacingBanner.length > 0);

const goToPage = (url) => {
	if (url.startsWith(process.env.VUE_APP_URL)) {
		const sliced = url.slice(process.env.VUE_APP_URL.length);
		router.push({ path: sliced });
	} else {
		window.location.href = url;
	}
};

const onSlideClick = (slide) => {
	if (!bannersStore.is_button_visible(slide.id) && slide.button_url) goToPage(slide.button_url);
}

onMounted(() => {
	is_rtl.value = document.documentElement.getAttribute('dir') === 'rtl';
});
</script>
<template>
	<section v-if="hasBanners">
		<div class="racing-banner-inner">
			<div class="slider">
				<div class="slides">
					<Splide :options="{ perPage: 1, drag: bannersStore.getRacingBanner.length > 1, arrows: false, pagination: bannersStore.getRacingBanner.length > 1, autoplay: bannersStore.getRacingBanner.length > 1, interval: 5000, type: bannersStore.getRacingBanner.length > 1 ? 'loop' : 'slide', direction: is_rtl ? 'rtl' : 'ltr'}">
						<SplideSlide v-for="slide in bannersStore.getRacingBanner" :key="slide.id">
							<div class="slide carousel__item" :class="{ 'is-clickable': !bannersStore.is_button_visible(slide.id) && slide.button_url }" @click="onSlideClick(slide)">
								<div class="racing-bg-image">
									<img :src="slide.media_url" alt="Image 1">
								</div>
								<div class="banner-content" id="banner-item">
									<h1>{{ slide.title }}</h1>
									<h5>{{ slide.sub_title }}</h5>
									<div v-if="bannersStore.is_button_visible(slide.id)" class="banner-btn">
										<a v-if="slide.button_url" @click="goToPage(slide.button_url)" class="btn bc-btn-lg btn-secondary">{{ slide.button_text }}</a>
									</div>
								</div>
							</div>
						</SplideSlide>
					</Splide>
				</div>
			</div>
		</div>
	</section>
</template>
<style scoped>
html[dir="rtl"] .slider  :deep(.splide__pagination) {
	width: 50%;
}

.is-clickable {
	cursor: pointer;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.banner-content .banner-btn {
		position: relative;
		font-weight: 400;
		text-align: left;
		margin-top: 12px;
	}

	.banner-content:has(a) h5 {
		width: 80%;
	}

	.slider {
		padding-top: 0 !important;
	}
}

.slider :deep(.splide__pagination) {
	bottom: 50px;
	top: auto;
}

@media screen and (max-width: 767px) {
	.slider :deep(.splide__pagination) {
		display: none;
	}
}
@media screen and (max-width: 425px) {
	.racing-main .sports-main-outer.live_Sports-main-outer.racing-outer-main .racing-outer-left .race-main-area .racing-banner-inner .racing-bg-image img {
		object-fit: fill;
	}
}
/* These styles will only apply if is_compact_banners_enabled is true */
@media screen and (min-width: 800px) {
	.compact-styles .slider {
		height: 65vh;
		min-height: 500px;
		max-height: 700px;
	}
}

html[dir=rtl] .compact-styles .slider .slides .slide .banner-main-image:before {
	transform:none;
}

.slider .slides .splide .splide__track:after,
.slider .slides .splide .splide__track:before{
	background-image: none;
}

.slider .slides .splide :deep(.splide__track:before) {
	background-image: unset;
}
.slider .slides .splide :deep(.splide__track) {
	height: auto;
}
.slider .slides .splide :deep(.splide__track:after) {
	background-image: unset;
}

.slider .slides .slide .banner-main-image:before {
	content: none;
}
.slider {
	height:30.5vh;
}
.banner-content h1 {
	font-size: 40px;
}
.banner-content {
	left: 64%;
}
@media screen and (min-width: 992px) and (max-width: 1468px) {
	.banner-content {
		right: auto;
		left: 75%;
		text-align: left;
	}
}
@media screen and (min-width: 320px) and (max-width: 768px) {
	.banner-content {
		left: auto;
		right: auto;
		left: 52%!important;
		text-align: left;
	}
	.banner-content h5 {
		text-align: left;
		width: 100%;
	}
	.banner-content h1 {
		text-align: left;
	}
	.banner-content h1 {
		font-size: 30px!important;
	}
	.banner-content .banner-btn {
		left: 0;
		right: auto;
		width: 100%;
	}
}
@media screen and (min-width: 768px) and (max-width: 991px) {
    .banner-content {
        top: 50%;
    }
}
@media screen and (min-width: 320px) and (max-width: 768px) {
	.banner-content {
		left: 64%;
	}
}
a.btn.bc-btn-lg.btn-secondary {
	font-size: 15px;
}
html[dir=rtl] .banner-content {
	right: auto;
	left: 35%;
	text-align: right;
}
@media screen and (min-width: 992px) and (max-width: 1280px) {
	html[dir=rtl] .banner-content {
		right: auto;
		left: 25%;
		text-align: right;
	}
}
@media screen and (max-width: 991px) {
	html[dir=rtl] .banner-content {
		right: auto;
		left: 45%;
		text-align: right;
		top: 104px;
	}
}

@media screen and (min-width: 320px) and (max-width: 768px) {
	html[dir=rtl] .banner-content {
		right: auto;
		left: 46%!important;
		text-align: right;
	}
	html[dir=rtl] .banner-content h5 {
		text-align: right;
		width: 100%;
	}
	html[dir=rtl] .banner-content h1 {
		text-align: right;
	}
	html[dir=rtl] .banner-content h1 {
		font-size: 30px!important;
	}
	html[dir=rtl] .banner-content .banner-btn {
		left: 0;
		right: auto;
		width: 100%;
	}
	html[dir=rtl] .banner-content .banner-btn {
		text-align:right!important;
	}
}
html[dir=rtl] .banner-content h1 {
	font-size: 40px;
}
.banner-content h5 {
	font-size: 16px;
	padding: 10px 0 10px;
}
</style>